import React from 'react'
import { Faq } from './Faq'
import { Policy } from '../Policy'
import '../../App.css'

export const PolicyAndFaq = () => {
  return (
    <>
    
        <Policy/>
        <Faq/>
    </>
  )
}
